import { render, staticRenderFns } from "./DewuData.vue?vue&type=template&id=2f4ea35d&scoped=true"
import script from "./DewuData.vue?vue&type=script&lang=js"
export * from "./DewuData.vue?vue&type=script&lang=js"
import style0 from "./DewuData.vue?vue&type=style&index=0&id=2f4ea35d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4ea35d",
  null
  
)

export default component.exports